
import {getProductByID, toAwning, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function FoldingArmPage() {

  return (
      GenericProductPage(getProductByID(59),toAwning)
  )
}
